var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "accordion-item" }, [
    _c("div", { staticClass: "accordion-header" }, [
      _c("h2", { staticClass: "custom-h accordion-title" }, [
        _c(
          "button",
          {
            staticClass: "custom-btn flex",
            attrs: {
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#" + _vm.collapseId,
              "aria-controls": _vm.collapseId,
              "aria-expanded":
                _vm.showCollapse || _vm.hasError ? "true" : "false",
            },
            on: {
              click: function ($event) {
                !_vm.disableToggle && _vm.toggle()
              },
            },
          },
          [
            _c(
              "span",
              { class: { required: _vm.required } },
              [
                _vm._t("title", function () {
                  return [_vm._v(_vm._s(_vm.title))]
                }),
              ],
              2
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "collapseElement",
        class: ["collapse", { show: _vm.showCollapse || _vm.hasError }],
        attrs: {
          id: _vm.collapseId,
          "data-parent": _vm.accordionParent ? "#" + _vm.accordionParent : null,
        },
      },
      [
        _c("div", { staticClass: "accordion-body" }, [
          _c(
            "form",
            { attrs: { action: "" } },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: true,
                        expression: "true",
                      },
                    ],
                  },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }